import React from "react";

interface ChangelogBodyProps {
  title: string;
  children: React.ReactNode;
}
export const ChangelogBody = ({ title, children }: ChangelogBodyProps): JSX.Element | null => {
  return (
    <>
      <p>
        <div className="font-semibold text-sm uppercase pb-1">{title}</div>
        <div className="space-y-3 text-sm">{children}</div>
      </p>
      <br />
    </>
  );
};
